import { render, staticRenderFns } from "./OptionsOrCustomInput.vue?vue&type=template&id=ef5f2838&scoped=true&"
import script from "./OptionsOrCustomInput.vue?vue&type=script&lang=ts&"
export * from "./OptionsOrCustomInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5f2838",
  null
  
)

export default component.exports